export const YANDEX_STORY_MAX_NAME_LENGTH = 14;
